import React from "react";
import "../CampaignComponent/CampaginComponentCss/PanchayatMissionSection.css";

import missionRightImg from "../Images/panchayatmissionsection.png";

export default function PanchayatMissionSection() {
  return (
    <section className="pm-section">
      <h2 className="pm-title">
        मुख्यमंत्री समृद्धपंचायतराज अभियानाचा <br />
        <span>(सन २०२५–२६)</span>
      </h2>

      <div className="pm-container">

        {/* LEFT SIDE BOX LIST */}
        <div className="pm-left">

          <div className="pm-box">
            <div className="pm-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1fa0ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7h20L12 2z"></path>
                <path d="M2 7v6c0 5 4 9 10 9s10-4 10-9V7"></path>
              </svg>
            </div>
            <p>नागरिकांना सुलभ रीतीने सेवा पुरविणे</p>
          </div>

          <div className="pm-box">
            <div className="pm-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1fa0ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="7" r="4"></circle>
                <path d="M5.5 21c1-4 3.5-6 6.5-6s5.5 2 6.5 6"></path>
              </svg>
            </div>
            <p>लोकांचे जीवनमान उंचावणे</p>
          </div>

          <div className="pm-box">
            <div className="pm-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1fa0ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="14" rx="2"></rect>
                <path d="M3 10h18"></path>
              </svg>
            </div>
            <p>आरोग्य, शिक्षण, उपजीविका, सामाजिक न्याय यामध्ये काम करणे</p>
          </div>

          <div className="pm-box">
            <div className="pm-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1fa0ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 2h6v4H9z"></path>
                <path d="M5 6h14v14H5z"></path>
              </svg>
            </div>
            <p>योजनांचा लाभ गावातील शेवटच्या घटकांपर्यंत पोहोचविणे</p>
          </div>

          <div className="pm-box">
            <div className="pm-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1fa0ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <p>विकासाच्या योजनांची प्रभावी व जलद गतीने अंमलबजावणी</p>
          </div>

        </div>

        {/* RIGHT SIDE IMAGE */}
        <div className="pm-right">
          <img src={missionRightImg} className="pm-right-img" alt="mission-section" />
        </div>

      </div>
    </section>
  );
}
